import { isWithinInterval } from 'date-fns';
import { useMemo } from 'react';

import { Milestone } from '../../apollo/__generated__/graphql';

export const useCurrentMilestone = (milestones: Milestone[]) => {
  return useMemo(() => {
    if (milestones.length === 0) {
      return null;
    }
    const now = new Date();
    return (
      milestones.find((milestone) =>
        isWithinInterval(now, {
          start: milestone.startAt,
          end: milestone.endAt,
        }),
      ) ?? null
    );
  }, [milestones]);
};
